import actionTypes from 'SRC/modules/redux/actionTypes'

export const setDeliveryInfo = deliveryInfo => ({
  type: actionTypes.SET_VEHICLE_PARTS_DELIVERY_INFO,
  payload: deliveryInfo
})
